import watchGetAccounts from './getAccounts';
import watchGetInvoices from './getInvoices';

const watchInvoices = [watchGetAccounts, watchGetInvoices];

export default watchInvoices;
